import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { AnimatedRingFill } from './styles.js';

export const AnimatedRingPath = ({
  d,
  strokeWidth,
  fillColor,
  score = 0,
  isInView = false,
  duration = 1.5,
}) => {
  const [dashOffset, setDashOffset] = useState(100);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!isInView) return undefined;

    const cappedScore = Math.min(score, 100);
    const targetOffset = 100 * (1 - cappedScore / 100);

    setIsAnimating(true);
    let innerFrame;
    const outerFrame = requestAnimationFrame(() => {
      innerFrame = requestAnimationFrame(() => {
        setDashOffset(targetOffset);
      });
    });

    return () => {
      cancelAnimationFrame(outerFrame);
      if (innerFrame) cancelAnimationFrame(innerFrame);
    };
  }, [isInView, score]);

  return (
    <AnimatedRingFill
      data-testid="animated-ring-path"
      d={d}
      pathLength={100}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      $fillColor={fillColor}
      $pathLength={100}
      $dashOffset={dashOffset}
      $isAnimating={isAnimating}
      $duration={duration}
    />
  );
};

AnimatedRingPath.displayName = 'AnimatedRingPath';

AnimatedRingPath.propTypes = {
  d: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  fillColor: PropTypes.string.isRequired,
  score: PropTypes.number,
  isInView: PropTypes.bool,
  duration: PropTypes.number,
};
